import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
type StartPageRedirectProps = {
  to: string;
};
export function StartPageRedirect({
  to
}: StartPageRedirectProps) {
  const navigate = useNavigate();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (to !== '/') navigate(to, {
      replace: true
    });
  }, [to, navigate]);
  return null;
}